<template>
  <div class="tf-vue-bg-grey-darker">
    <a
      href="javascript:void(0)"
      class="text-white text-decoration-none d-flex align-items-center justify-content-center w-100 h-100 px-3"
      data-bs-toggle="modal"
      data-bs-target="#destModal"
    >
      <i class="icon-information px-1"></i>
    </a>

    <div
      id="destModal"
      class="modal"
      @change="destination"
      tabindex="-1"
      ref="destModal"
      aria-labelledby="destModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content text-dark p-4">
          <!-- EUROPE  -->
          <div v-if="showEuropeBody">
            <h4>Europe</h4>
            <p class="fw-bold">
              Europe means the continent of Europe West of the Ural Mountains, and includes the Isle of Man, the Channel Islands, Iceland, Jordan, Madeira, the Canary, Azores and Mediterranean Islands, as well as the countries bordering the Mediterranean.
            </p>
            <div>
              <p class="fw-bold" v-if="domain === 'ie'">
                There is no cover provided in the below listed sections, relating to emergency medical expenses, for holidays taken within Ireland.
              </p>
              <p class="fw-bold" v-else>
                There is no cover provided in the below listed sections, relating to emergency medical expenses, for holidays taken within the United Kingdom:
              </p>
              <p>TF Travel Insurance: Sections A1,A2, A3, A4 & A6.</p>
              <p>TF Backpacker Travel Insurance: F & G</p>
            </div>
          </div>

          <!-- AUS & NZ  -->
          <div v-if="showAusNZBody">
            <h4>Australia and New Zealand</h4>
            <ul class="fw-bold">
              <li>
                Includes a 60 hour stopover anywhere in the world for both
                outward and return travel.
              </li>
            </ul>
          </div>

          <!-- EXCLUDING NA  -->
          <div v-if="showExcludingNABody">
            <h4> Worldwide excluding the USA & Canada (North America)</h4>
            <ul class="fw-bold">
              
              <li class="mt-3">
                Includes a 60 hour stopover anywhere in the world for both outward and return travel.

              </li>
            </ul>
          </div>

          <!-- WORLD WIDE  -->
          <div v-if="showWorldWideBody">
            <h4>Worldwide</h4>
            <p class="fw-bold">
              Valid for travel for any period of cover anywhere in the world.
            </p>
          </div>

          <div class="text-center">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["destination", "domain"],
  data() {
    return {
      modalTitle: "",
      showEuropeBody: false,
      showAusNZBody: false,
      showExcludingNABody: false,
      showWorldWideBody: false,
      modalShow: false,
    };
  },
  mounted() {
    this.showEuropeBody = true;
  },
  watch: {
    destination(value) {
      if (value === "1") {
        this.showEuropeBody = true;
        this.showAusNZBody = false;
        this.showExcludingNABody = false;
        this.showWorldWideBody = false;
        this.modalTitle = "Europe";
      }
      if (value === "2") {
        this.showAusNZBody = true;
        this.showEuropeBody = false;
        this.showExcludingNABody = false;
        this.showWorldWideBody = false;
        this.modalTitle = "Australia and New Zealand";
      }
      if (value === "3") {
        this.showExcludingNABody = true;
        this.showEuropeBody = false;
        this.showAusNZBody = false;
        this.showWorldWideBody = false;
        this.modalTitle = "Worldwide excluding the USA & Canada (North America)";
      }
      if (value === "4") {
        this.showWorldWideBody = true;
        this.showEuropeBody = false;
        this.showAusNZBody = false;
        this.showExcludingNABody = false;
        this.modalTitle = "Worldwide INCLUDING North America";
      }
    },
  },
};
</script>
<style scoped></style>
